import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { legendAreas } from '../utils/legendRows';
import ChevronRight from '../../shared/Icons/ChevronRight';
import '../styles/seatMapLegend.css';
import '../styles/seatInventory.css';

const UNAVAILABLE_CHIP = { label: 'Unavailable', color: '#D5D7DA' };

const SeatMapLegend = ({ rows, categories, onFocusCategory, disabled }) => {
  const [activeKey, setActiveKey] = useState(null);
  const [chipsOpen, setChipsOpen] = useState(false);

  const areas = legendAreas(rows || []);
  const areaKeysSignature = areas.map((area) => area.key).join('|');

  useEffect(() => {
    if (activeKey && !areas.some((area) => area.key === activeKey)) {
      setActiveKey(null);
      if (onFocusCategory) {
        onFocusCategory(null);
      }
    }
  }, [areaKeysSignature]);

  if (!rows || rows.length === 0) {
    return null;
  }

  const areaCount = areas.length;
  const activeIndex = activeKey ? areas.findIndex((area) => area.key === activeKey) + 1 : 0;

  const focusKey = (key) => {
    setActiveKey(key);
    if (onFocusCategory) {
      onFocusCategory(key);
    }
  };

  const step = (delta) => {
    const positions = areaCount + 1;
    const nextIndex = ((activeIndex + delta) % positions + positions) % positions;
    focusKey(nextIndex === 0 ? null : areas[nextIndex - 1].key);
  };

  const tourLabel = activeIndex === 0
    ? `Tour all ${areaCount} ${areaCount === 1 ? 'area' : 'areas'}`
    : `${areas[activeIndex - 1].name} (${activeIndex} of ${areaCount})`;

  return (
    <div className="seat-map-legend">
      {areaCount > 2 && (
        <div className="seat-map-legend-header">
          <span className="seat-map-legend-tour-label">{tourLabel}</span>
          <span className="seat-map-legend-tour-steppers">
            <button type="button" aria-label="Previous area" disabled={disabled} onClick={() => step(-1)}><ChevronRight /></button>
            <button type="button" aria-label="Next area" disabled={disabled} onClick={() => step(1)}><ChevronRight /></button>
          </span>
        </div>
      )}

      <div className="seat-map-legend-float">
        {chipsOpen && (
          <div className="seat-map-legend-chips">
            {[...(categories || []), UNAVAILABLE_CHIP].map((chip) => (
              <span key={chip.key || chip.label} className="seat-map-legend-chip">
                <span className="seat-map-legend-chip-dot" style={{ backgroundColor: chip.color }} />
                <span className="seat-map-legend-chip-label">{chip.label}</span>
              </span>
            ))}
          </div>
        )}
        <button type="button"
                className="seat-map-legend-toggle"
                aria-expanded={chipsOpen}
                onClick={() => setChipsOpen((open) => !open)}>
          Legend
          <ChevronRight />
        </button>
      </div>
    </div>
  );
};

SeatMapLegend.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string,
      color: PropTypes.string,
      categoryKey: PropTypes.string,
      generalAdmissionLabels: PropTypes.arrayOf(PropTypes.string),
      soldOut: PropTypes.bool
    })
  ),
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      color: PropTypes.string
    })
  ),
  onFocusCategory: PropTypes.func,
  disabled: PropTypes.bool
};

export default SeatMapLegend;
